import { JsonDecoder } from 'ts.data.json';
import { CustomTemplate, CustomTemplateCreate, CustomTemplateUpdate } from './model';

export const customTemplateDecoder = JsonDecoder.object<CustomTemplate>(
    {
        id: JsonDecoder.number,
        userId: JsonDecoder.number,
        type: JsonDecoder.string,
        isPrimary: JsonDecoder.boolean,
        body: JsonDecoder.string,
        subject: JsonDecoder.string,
        name: JsonDecoder.string,
        createdAt: JsonDecoder.string,
        updatedAt: JsonDecoder.optional(JsonDecoder.string),
        deletedAt: JsonDecoder.optional(JsonDecoder.string)
    },
    'CustomTemplate'
);

export const customTemplateCreateDecoder = JsonDecoder.object<CustomTemplateCreate>(
    {
        id: JsonDecoder.number,
        type: JsonDecoder.string,
        isPrimary: JsonDecoder.boolean,
        body: JsonDecoder.string,
        subject: JsonDecoder.string,
        name: JsonDecoder.string
    },
    'CustomTemplateCreate'
);

export const customTemplateUpdateDecoder = JsonDecoder.object<CustomTemplateUpdate>(
    {
        id: JsonDecoder.number,
        type: JsonDecoder.string,
        isPrimary: JsonDecoder.boolean,
        body: JsonDecoder.string,
        subject: JsonDecoder.string,
        name: JsonDecoder.string
    },
    'CustomTemplateUpdate'
);

export const customTemplatesDecoder = JsonDecoder.array<CustomTemplate>(
    customTemplateDecoder,
    'CustomTemplate[]'
);
